import * as React from "react";
type Props = {
  className?: string,
};
function SvgCart2({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-cart2"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.5 19C10.3284 19 11 19.6716 11 20.5C11 21.3285 10.3284 22 9.5 22C8.67157 22 8 21.3285 8 20.5C8 19.6716 8.67157 19 9.5 19ZM16.5 19C17.3284 19 18 19.6716 18 20.5C18 21.3285 17.3284 22 16.5 22C15.6716 22 15 21.3285 15 20.5C15 19.6716 15.6716 19 16.5 19ZM3 1.58582L5.41378 3.99982L21 4.00003C21.5587 4.00003 22.0006 4.45505 22.0001 4.99907L21.9931 5.11687L21.052 13.1169C20.9973 13.5817 20.6294 13.9409 20.1743 13.9934L20.0588 14L7.51378 13.9998L7.847 16H20V18H7C6.5519 18 6.164 17.7031 6.04056 17.2822L6.0136 17.1644L4.066 5.48103L1.58578 3.00003L3 1.58582ZM15.5742 6.15936L12.102 9.57503L10.3595 7.87438L9.13725 9.12681L12.1079 12.0258L16.8017 7.40668L15.5742 6.15936Z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgCart2;
